module.exports = __webpack_public_path__ + "ecdc2099a67803ff421263a582b55806.svg";